import { Col, Row } from 'antd';
import React, {useEffect} from 'react'
import { useTranslation } from 'react-i18next';
import "./statistic-box.scss";

const StatisticBox = ({
    statObj,
    count,
    context,
    onClick,
    icon,
    iconSrc
}) => {

    const { t } = useTranslation();

    const handleBoxClick = (ref: string) => {
        onClick(ref);
    }

    return (
        <div className={`statObj ${statObj.name}`}
            onClick={() => handleBoxClick(statObj.tab)}>
            <div className="p-15 mr-5 txt-container">
                <div className="count">{count ? count : 0}</div>
                <div className="text mt-10">{t(`txt.${statObj.name + context}`)}</div>
            </div>
            <div className="icon-container">
                {/*{icon}*/}
              {iconSrc ? <img src={iconSrc} alt="" width={30} height={45}/> : icon}
            </div>
        </div>
    )
}

export default StatisticBox
